module.exports = __webpack_public_path__ + "static/media/fabrics.78416cf1.png";